import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import tokens from '@verifime/design-tokens';
import { ReactNode, useState } from 'react';

export default function MoreOptions({
  leadingContent,
  onCancel,
  onConfirm,
}: Readonly<{
  leadingContent?: ReactNode;
  onCancel?: () => void;
  onConfirm?: () => void;
}>) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>More options &gt;</Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>More Options</DialogTitle>
        <DialogContent>
          <Stack gap={tokens.spacingXs}>
            {leadingContent && leadingContent}
            <Typography variant="body2">
              You may choose to not complete a Face Check if you are not ready yet.
            </Typography>
            <Typography variant="body2">
              Please be aware that your service provider can choose to decline service in the
              absence of a valid Face check.
            </Typography>
            <Typography variant="body2">
              You can complete this at a later time from within the VerifiMe portal.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              onCancel?.();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              onConfirm?.();
            }}
          >
            Skip Face Check For Now
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
